import gql from 'graphql-tag';
import { useQuery } from '@apollo/client';
import { useAccountContext } from 'contexts/account';

export const usePromoCode = () => {
  const { userId } = useAccountContext();
  const { data } = useQuery(GET_PROMO_CODE, {
    variables: { userId },
    skip: !userId,
  });

  return data?.user?.signupPromoCode?.code;
};

export const GET_PROMO_CODE = gql`
  query getPromoCode($userId: Int!) {
    user(id: $userId) {
      signupPromoCode {
        code
      }
    }
  }
`;
